import React from "react";
import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
import Topbar from "../../components/Super Admin/TopBar/TopbarCenterManagement";
import AddStationsTable from "../../components/Super Admin/Center Management/AddStationsTable";
import "../../css/AddStationsPage.css";

const AddStationsPage: React.FC = () => {
  return (
    <>
        <Topbar />
        <AddStationsTable />
    </>
  );
};

export default AddStationsPage;
